export enum CaseStatuses {
  NotSet = 'NOT_SET',
  Completed = 'COMPLETED',
  ApplicationReceived = 'APPLICATION_RECEIVED',
  InitialAssessment = 'INITIAL_ASSESSMENT',
  ValuationInstructed = 'VALUATION_INSTRUCTED',
  OfferIssued = 'OFFER_ISSUED',
  COTOutstandingItems = 'COT_OUTSTANDING_ITEMS',
  COTReceived = 'COT_RECEIVED',
  COTReviewed = 'COT_REVIEWED',
  COTCancelled = 'COT_CANCELLED',
  ReleaseOfFundsApproved = 'RELEASE_OF_FUNDS_APPROVED',
  FundsReleased = 'FUNDS_RELEASED',
  CompletionDelayed = 'COMPLETION_DELAYED',
  FundsToBeReturned = 'FUNDS_TO_BE_RETURNED',
  Withdrawn = 'WITHDRAWN',
  Rejected = 'REJECTED',
}
